export { default } from '@shikijs/langs/diff'
